import React from 'react';
import ReactDOM from 'react-dom';

/**
 * A React portal confirmation dialog to replace raw document.createElement hacks.
 *
 * Drive it with `useConfirm()` rather than hand-rolled state — the hook owns
 * the open/closed flag and hands back an awaitable `confirm(message, options)`:
 *
 *   const { confirm, confirmDialogProps } = useConfirm();
 *
 *   const handleDelete = async () => {
 *     if (!await confirm('Are you sure?', { danger: true })) return;
 *     // ...
 *   };
 *
 *   // In JSX:
 *   {confirmDialogProps && <ConfirmDialog {...confirmDialogProps} />}
 */
export function ConfirmDialog({ message, title, onConfirm, onCancel, confirmLabel = 'Confirm', cancelLabel = 'Cancel', danger = false, isProcessing = false }) {
  return ReactDOM.createPortal(
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label={title || 'Confirmation'}>
      <div className="confirm-dialog">
        {title && <h3 className="confirm-dialog-title">{title}</h3>}
        <p className="confirm-dialog-message">{message}</p>
        <div className="confirm-dialog-actions">
          <button
            className="confirm-dialog-cancel"
            onClick={onCancel}
            disabled={isProcessing}
          >
            {cancelLabel}
          </button>
          <button
            className={`confirm-dialog-confirm${danger ? ' confirm-dialog-danger' : ''}`}
            onClick={onConfirm}
            autoFocus
            disabled={isProcessing}
          >
            {isProcessing ? 'Processing...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
